import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';
import axios from 'axios';

// Async thunk for customer validation
export const validateCustomerMainData = createAsyncThunk(
  'customer/validateCustomerMainData',
  async ({ customerName, phoneNumber, taxId,language  }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/api/Customer/ValidateCustomerMainData', {
        customerName,
        phoneNumber,
        taxId,
      }, {
        headers: {
          'Accept': 'text/plain',
          'Content-Type': 'application/json-patch+json',
          'lang': language,
        },
      });

      // Return the response data
      return response.data;
    } catch (error) {
      // Handle error
      return rejectWithValue(error.response?.data?.errormessage || error.message);
    }
  }
);

// Slice for customer validation
const customerValidateSlice = createSlice({
  name: 'customer',
  initialState: {
    loading: false,
    error: null,
    validationResult: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(validateCustomerMainData.pending, (state) => {
        state.loading = true;
      })
      .addCase(validateCustomerMainData.fulfilled, (state, action) => {
        state.loading = false;
        state.validationResult = action.payload;
      })
      .addCase(validateCustomerMainData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default customerValidateSlice.reducer;
